var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog", class: { active: _vm.showDialog } },
    [
      _c(
        "div",
        { staticClass: "dialog--content u-extra-large-padding--top" },
        [
          _vm.message ? [_c("p", [_vm._v(_vm._s(_vm.message))])] : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center u-extra-medium-margin--bottom" },
            [
              _c("v-page-loading", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button",
                  attrs: {
                    disabled: _vm.isLoading,
                    href: _vm.pdfUrl,
                    target: "_blank",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("download")))]
              ),
              _vm._v(" "),
              _vm.pdfError
                ? _c("div", [_c("p", [_vm._v("Fehler bei der PDF-Erzeugung")])])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCloseDialog()
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }